export default [
  {
    path: '/public',
    name: 'PublicRoot',
    component: require('@/pages/Public/Coaches').default,
  },
  {
    path: '/public/coaches',
    name: 'PublicCoaches',
    component: require('@/pages/Public/Coaches').default,
  },
  {
    path: '/public/coach/:id',
    name: 'PublicCoachDetail',
    component: require('@/pages/Public/CoachDetail').default,
  },
  {
    path: '/public/coach/:id/reviews/:reviewId?',
    name: 'PublicCoachReviews',
    component: require('@/pages/Public/CoachReviews').default,
  },
  {
    path: '/public/application',
    name: 'PublicApplication',
    component: require('@/pages/Public/Application').default,
  },
  {
    path: '/public/application/done',
    name: 'PublicApplicationDone',
    component: require('@/pages/Public/ApplicationDone').default,
  },
  {
    path: '/public/sign_up/:coachId?',
    name: 'PublicSignUp',
    component: require('@/pages/Public/SignUp').default,
  },
  {
    path: '/public/sign_up/:coachId/done',
    name: 'PublicSignUpDone',
    component: require('@/pages/Public/SignUpDone').default,
  },
  {
    path: '/public/apply_password_reset',
    name: 'PublicApplyPasswordReset',
    component: require('@/pages/Public/ApplyPasswordReset').default,
  },
  {
    path: '/public/apply_password_reset_done',
    name: 'PublicApplyPasswordResetDone',
    component: require('@/pages/Public/ApplyPasswordResetDone').default,
  },
  {
    path: '/public/invalid_token',
    name: 'PublicInvalidToken',
    component: require('@/pages/Public/InvalidToken').default,
  },
  {
    path: '/public/privacypolicy',
    name: 'PublicPrivacypolicy',
    component: require('@/pages/Public/PrivacyPolicy').default,
  },
  {
    path: '/public/termsofuse',
    name: 'PublicTermsofuse',
    component: require('@/pages/Public/TermsOfUse').default,
  },
  {
    path: '/public/tokushoho',
    name: 'PublicTokushoho',
    component: require('@/pages/Public/Tokushoho').default,
  },
  {
    path: '/public/avex_coaches',
    name: 'PublicAvexCoaches',
    component: require('@/pages/Public/AvexCoaches').default,
  },
  {
    path: '/public/avex_coaches/:id',
    name: 'PublicAvexCoachDetail',
    component: require('@/pages/Public/AvexCoachDetail').default,
  },
  {
    path: '/public/live_lesson/:token',
    name: 'PublicLiveLesson',
    component: require('@/pages/Public/LiveLesson').default,
  },
  {
    path: '/public/app',
    name: 'AppLink',
    component: require('@/pages/Public/AppLink').default,
  },
]
